import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SolicitacaoAuxSaudeService } from 'app/service/solicitacao-aux-saude/solicitacao-aux-saude.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-rejeitar',
  templateUrl: './modal-rejeitar.component.html',
  styleUrls: ['./modal-rejeitar.component.sass']
})
export class ModalRejeitarComponent implements OnInit {
  listaMotivos:any[] = []
  motivo: number = null;
  justificativa: string = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private solicitacaoAuxSaudeService: SolicitacaoAuxSaudeService,
    private toasterService: ToastrService) { }

  ngOnInit(): void {
    this.solicitacaoAuxSaudeService.getTipoRejeicao().subscribe((result) => {
      this.listaMotivos = result
    })
  }

  salvar() {
    if(this.motivo !== null && this.justificativa !== null && this.justificativa !== ''){
      const data = {
        motivo: this.motivo,
        justificativa: this.justificativa
      }
      this.data.acaoOk(data)
    }
    else{
      if(this.motivo === null){
        this.toasterService.warning('Selecione um motivo')
      }
      if(this.justificativa === null || this.justificativa === ''){
        this.toasterService.warning('Informe uma justificativa')
      }
    }
  }

}
